const priceFormatting = (amount, language, device) => {
  return Intl.NumberFormat(language, {
    style: "currency",
    currency: device
  }).format(Number(amount));
};

export default priceFormatting;
